(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["futurebotics-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var atcBtn = document.querySelector('[data-fb-atc-btn]');
  var sticky = document.querySelector('[data-fb-sticky]');

  if (atcBtn && sticky && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
        sticky.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0 });
    observer.observe(atcBtn);
  }

  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-gallery-thumb]');
    if (thumb) {
      var mediaId = thumb.getAttribute('data-media-id');
      var mediaWrap = thumb.closest('.fb__media');
      if (!mediaWrap) return;
      mediaWrap.querySelectorAll('.fb__media-item').forEach(function (item) {
        item.classList.remove('fb__media-item--active');
      });
      var target = mediaWrap.querySelector('.fb__main-wrap [data-media-id="' + mediaId + '"]');
      if (target) {
        target.classList.add('fb__media-item--active');
        var counter = mediaWrap.querySelector('[data-media-counter]');
        if (counter) {
          var idx = target.getAttribute('data-media-index') || '1';
          var total = mediaWrap.querySelectorAll('.fb__media-item').length;
          counter.textContent = idx + ' / ' + total;
        }
      }
      mediaWrap.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
        t.classList.remove('fb__thumb--active');
      });
      thumb.classList.add('fb__thumb--active');
      return;
    }

    var viewAll = e.target.closest('[data-view-all]');
    if (viewAll) {
      var modal = document.getElementById('fb-media-modal');
      if (modal) modal.classList.add('fb-modal--open');
      document.body.style.overflow = 'hidden';
      return;
    }

    var closeBtn = e.target.closest('[data-modal-close]');
    if (closeBtn) {
      var modal = document.getElementById('fb-media-modal');
      if (modal) modal.classList.remove('fb-modal--open');
      document.body.style.overflow = '';
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = document.getElementById('fb-media-modal');
      if (modal && modal.classList.contains('fb-modal--open')) {
        modal.classList.remove('fb-modal--open');
        document.body.style.overflow = '';
      }
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
